import AbstractSurveyFormField from './AbstractSurveyFormField';

class SurveyCheckboxButtonsFormField extends AbstractSurveyFormField {
    options = [];
    other = null;
    otherInput = null;

    constructor(element, options) {
        super(element, { ...options, type: 'survey_checkbox_buttons' });

        const items = this.element.getElementsByClassName('question-option');
        for (let i = 0; i < items.length; i++) {
            this.options.push(items[i]);
        }

        this.options.forEach((option) => {
            option.addEventListener('click', () => {
                option.classList.toggle('active');
                this.syncOtherState();
                this.handleChanges(this);
            });
        });

        const other = this.element.getElementsByClassName('survey-checkbox-buttons-other');
        if (other.length) {
            this.other = other[0];
            this.otherInput = this.other.getElementsByClassName('survey-checkbox-buttons-other-input')[0] ?? null;
        }

        if (this.otherInput) {
            this.otherInput.addEventListener('keyup', this.handleChanges.bind(this));
        }

        this.syncOtherState();
    }

    syncOtherState() {
        if (!this.other) {
            return;
        }

        const otherOption = this.options.find((option) => option.dataset.isOther === '1');
        if (otherOption && otherOption.classList.contains('active')) {
            this.other.classList.add('active');
        } else {
            this.other.classList.remove('active');
        }
    }

    getValue() {
        const values = [];

        this.options.forEach((option) => {
            if (!option.classList.contains('active')) {
                return;
            }

            if (option.dataset.isOther === '1') {
                const otherValue = this.otherInput ? this.otherInput.value.trim() : '';
                values.push(otherValue.length ? `Other: ${otherValue}` : 'Other');
                return;
            }

            values.push(option.dataset.value);
        });

        return values.join(', ');
    }
}

export default SurveyCheckboxButtonsFormField;